export enum RecognitionResultStatus {
    active = "active",
    published = "published",
    recognized = "recognized",
    generatingSummary = "generatingSummary",
    waitingForSummary = "waitingForSummary",
    waitingForRecognition = "waitingForRecognition",
    error = "error"
}

export enum RRSwitchStatus {
    off = "Off",
    published = "Published"
}
